/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

import * as React from "react";
import { createUseScreenVariants } from "@plasmicapp/react-web";

export type ThemePurpleDarkValue = "override";
export const ThemePurpleDarkContext = React.createContext<
  ThemePurpleDarkValue | undefined
>("PLEASE_RENDER_INSIDE_PROVIDER" as any);
export function ThemePurpleDarkContextProvider(
  props: React.PropsWithChildren<{ value: ThemePurpleDarkValue | undefined }>
) {
  return (
    <ThemePurpleDarkContext.Provider value={props.value}>
      {props.children}
    </ThemePurpleDarkContext.Provider>
  );
}

export function useThemePurpleDark() {
  return React.useContext(ThemePurpleDarkContext);
}

export default ThemePurpleDarkContext;
/* prettier-ignore-end */
